import { z } from 'zod';
import { HouseEdgeBps } from './money';

/**
 * Versus mode talks in seats, not players.
 *
 * The platform knows which player holds which seat; the engine never does. That
 * is deliberate: a peer game's outcome must be a function of the moves, so the
 * engine cannot favour a player it cannot see.
 */
export const VersusSeat = z.enum(['CREATOR', 'CHALLENGER']);
export type VersusSeat = z.infer<typeof VersusSeat>;

export const VersusRoundWinner = z.enum(['CREATOR', 'CHALLENGER', 'TIE']);
export type VersusRoundWinner = z.infer<typeof VersusRoundWinner>;

/**
 * How a decided match pays out. The platform holds the escrow, so it applies
 * the rule; the engine only says which one applies.
 */
export const VersusPayoutRule = z.discriminatedUnion('type', [
  z.object({
    /** Winner receives both stakes less the house edge. */
    type: z.literal('WINNER_TAKES_POT'),
    houseEdgeBps: HouseEdgeBps,
  }),
  z.object({
    /** Nobody won: both stakes are returned in full. */
    type: z.literal('REFUND_BOTH'),
  }),
]);
export type VersusPayoutRule = z.infer<typeof VersusPayoutRule>;
